let _authorize = null;
let _STATE;

//keys
const STUDY = "STUDY";
const MASTER_ICFS = "MASTER_ICFS";
const SITES = "SITES";
const CROS = "CROS";
const CRO_MANAGERS = "CRO_MANAGERS";
const INVESTIGATORS = "INVESTIGATORS";
const MILESTONES = "MILESTONES";
//values

const keys = {
  //Keys
  STUDY,
  MASTER_ICFS,
  SITES,
  CROS,
  CRO_MANAGERS,
  INVESTIGATORS,
  MILESTONES,
};

const consts = {};

//models
const studyModel = {
  tmpId: "",
  name: "",
  estimatedDuration: "",
  thresholdOfParticipants: "",
  croId: "",
  masterIcfs: [],
  cros: [],
  sites: [],
  milestones: [],
};

const masterIcfModel = {
  tmpId: "",
  name: "",
};

const milestoneModel = {
  tmpId: "",
  masterIcfId: "",
  name: "",
  description: "",
  mandatory: false,
};

const siteModel = {
  tmpId: "",
  studyId: "",
  masterIcfId: "",
  name: "",
  address: "",
  siteIcfs: [],
  investigators: [],
};

const siteIcfModel = {
  tmpId: "",
  studyId: "",
  siteId: "",
  fileLink: "",
};

const croModel = {
  tmpId: "",
  studies: [],
  croManagers: [],
  data: {},
};

const croManagerModel = {
  tmpId: "",
  userId: "",
  cros: [],
  name: "",
  email: "",
  data: {},
};

const investigatorModel = {
  tmpId: "",
  siteId: "",
  name: "",
  email: "",
  phoneNumber: "",
  data: {},
};

const models = {
  studyModel,
  masterIcfModel,
  milestoneModel,
  siteModel,
  siteIcfModel,
  croModel,
  croManagerModel,
  investigatorModel,
};

const init = ({ authorize }) => {
  !_authorize && (_authorize = authorize);
};

const STATE = {
  [STUDY]: studyModel,
  [MASTER_ICFS]: [],
  [SITES]: [],
  [CROS]: [],
  [CRO_MANAGERS]: [],
  [INVESTIGATORS]: [],
  [MILESTONES]: [],
};

const reloadState = (authorize) => {
  if (authorize !== _authorize) {
    return {
      success: false,
      message: "Unauthorized",
      fromError: null,
      errorCode: "unauthorized-error",
      errorKey: 663936,
    };
  }
  return STATE;
};

const setValue = (authorize, keyName, value) => {
  if (authorize !== _authorize) {
    return {
      success: false,
      message: "Unauthorized",
      fromError: null,
      errorCode: "unauthorized-error",
      errorKey: 840065,
    };
  }
  STATE[keyName] = value;
};

const reset = (authorize) => {
  if (authorize !== _authorize) {
    return {
      success: false,
      message: "Unauthorized",
      fromError: null,
      errorCode: "unauthorized-error",
      errorKey: 585927,
    };
  }
  STATE[STUDY] = studyModel;
  STATE[MASTER_ICFS] = [];
  STATE[SITES] = [];
  STATE[CROS] = [];
  STATE[CRO_MANAGERS] = [];
  STATE[INVESTIGATORS] = [];
  STATE[MILESTONES] = [];
};

const CurrentStudyState = {
  //Keys
  KEYS: { ...keys },
  ...keys,
  //Values
  CONSTS: { ...consts },
  ...consts,
  MODELS: { ...models },
  ...models,
  init,
  reset,
  reloadState,
  setValue,
};

export default CurrentStudyState;

export {
  keys as KEYS,
  consts as CONSTS,
  models as MODELS,
  STUDY,
  MASTER_ICFS,
  SITES,
  CROS,
  CRO_MANAGERS,
  INVESTIGATORS,
  MILESTONES,
};
